export default {
  store: {
    type: Object,
    default: () => {},
  },
  formData: {
    type: Object,
    default: () => {},
  },
  extendData: {
    type: Object,
    default: () => {},
  },
  /** @name 是否开启根据系统策略IWMS_SCAN_AUTO_OPEN_SERIAL的值判断是否扫码自动开启序列号管理 */
  isCheckAutoSerial: {
    type: Boolean,
    default: false,
  },
  //查询库存的接口
  queryStorageItemUrl: {
    type: String,
    default: '',
  },
  /** @name 扫码查询商品档案的策略 */
  queryGoodsOfStrategy: {
    type: Object,
    default() {
      return {
        strategy: 'default', // 默认: default / null，手术记账: bookkeeping
        url: '',
        method: 'post',
        params: {},
      }
    },
  },
  //单挑库存的保存接口
  saveDatatUrl: {
    type: String,
    default: '',
  },
  //数量的字段可配置
  dataAmountKey: {
    type: String,
    default: 'amount', // 可能的值 amount
  },
  //扫码查询数据的接口
  tableDataInfoUrl: {
    type: String,
    default: '',
  },
  //扫码查询数据的方法
  tableDataInfoMethod: {
    type: String,
    default: 'post',
  },
  //扫码查询数据的参数
  tableDataInfoParameters: {
    type: Object,
  },
  // 查询库存的接口
  queryStockOfUrl: {
    type: String,
    default: '',
  },
  // 查询库存的接口方法
  queryStockOfMethod: {
    type: String,
    default: 'post',
  },
  // 查询库存的接口参数
  queryStockOfParams: {
    type: Object,
    default() {
      return {}
    },
  },
  //页数查询
  pageSize: {
    type: Number,
    default: 10,
  },
  // 添加商品明细的接口
  createItemOfUrl: {
    type: String,
    default: '',
  },
  // 查询库存的接口方法
  createItemOfMethod: {
    type: String,
    default: 'post',
  },
  // 查询库存的接口参数
  createItemOfParams: {
    type: Object,
    default() {
      return {}
    },
  },
  // 自定义事件名（用于配置在按钮上自定义组件）
  eventName: {
    type: String,
    default: 'on-ok-and-continue',
  },
  // 传递的额外参数，例如：传递给 store
  eventParams: {
    type: Object,
  },
  /** @name 确认提交时，是否禁止清空扫码区域表单 */
  disabledClearForSubmit: {
    type: Boolean,
    default: false,
  },
  /**
   * @name 外部出入的错误提示信息
   * 数据结构:
   * {
   *   type: 'error' | 'warn',
   *   message: ''
   * }
   */
  errorMessage: {
    type: Object,
  },
  // 是否反算日期
  isCalcDate: {
    type: Boolean,
    default: true,
  },
  // 键名转换映射表
  propMap: {
    type: Object,
    default() {
      return {
        batchNumber: `${this.dataGoodsKeepingKey}.batchNumber`,
        serialNumber: `${this.dataGoodsKeepingKey}.serialNumber`,
        periodBegin: `${this.dataGoodsKeepingKey}.periodBegin`,
        periodEnd: `${this.dataGoodsKeepingKey}.periodEnd`,
      }
    },
  },
  // 获取商品失败的错误提示信息
  queryGoodsErrorMessage: {
    type: String,
    default: '系统找不到对应的商品档案',
  },
  // 未包含全球唯一标识的错误提示信息
  gtinErrorMessage: {
    type: String,
    default: '请先扫描全球唯一标识',
  },
  // 识别失败的错误提示信息
  analysisErrorMessage: {
    type: String,
    default: '系统无法识别此类信息',
  },
  // 未开启序列号管理的错误提示信息
  serialErrorMessage: {
    type: String,
    default: '该商品未启用序列号管理',
  },
  /**
   * DI 区域表单项
   * 数据结构:
   * {
   *    code: 'code',
   *    valueKey: 'code',
   *    name: '商品编号',
   *    visiable(可选): true(显示) | false(隐藏)，默认: 显示
   *    style(可选): {width: '125px'},
   *    component(可选): 'Input', 默认: Input
   *    parameter(可选): {
   *      urlQuery: '请求接口地址’,
   *      requestMethod: '请求方法 默认: get',
   *      valueKey(可选): 'value的key, 默认: value',
   *      labelKey(可选): 'label的key, 默认: label'
   *    },
   *    props(可选): {clearable: true}
   * }
   */
  diAreaColumns: {
    type: Array,
    default() {
      return [
        {
          code: `${this.dataGoodsInfoKey}.code`,
          name: '商品编号',
          style: { width: '190px' },
          props: { clearable: true, required: true },
        },
        {
          code: `${this.dataGoodsInfoKey}.name`,
          name: '商品名称',
          style: { width: '190px' },
          props: { clearable: true, required: true },
        },
        {
          code: `${this.dataGoodsInfoKey}.model`,
          name: '规格/型号',
          style: { width: '190px' },
          props: { clearable: true },
        },
        {
          code: `${this.dataGoodsInfoKey}.manufacturer.name`,
          name: '生产企业',
          style: { width: '190px' },
          props: { clearable: true },
        },
        {
          code: `${this.dataGoodsInfoKey}.number`,
          name: '厂家物料编码',
          style: { width: '190px' },
          props: { clearable: true },
        },
        {
          code: `gtin`,
          name: '全球唯一标识',
          style: { width: '190px' },
          props: { clearable: true, required: true },
        },
        {
          code: `${this.dataGoodsKeepingKey}.batchNumber`,
          name: '批号',
          style: { width: '190px' },
          props: { clearable: true },
        },
        {
          code: `${this.dataGoodsKeepingKey}.serialNumber`,
          name: '序列号',
          style: { width: '190px' },
          props: { clearable: true },
        },
        {
          code: `${this.dataGoodsKeepingKey}.periodBegin`,
          name: '生产日期',
          style: { width: '190px' },
          component: 'panguDatePicker',
          props: { clearable: true },
        },
        {
          code: `${this.dataGoodsKeepingKey}.periodEnd`,
          name: '效期',
          style: { width: '190px' },
          component: 'panguDatePicker',
          props: { clearable: true },
        },
      ]
    },
  },
  /**
   * 补充信息区域表单项
   * 数据结构:
   * {
   *    code: 'markinfo',
   *    valueKey(可选): 'code',
   *    name: '验收结论',
   *    style(可选): {width: '135px'},
   *    component(可选): 'Input', 默认: Input
   *    parameter(可选): {
   *      urlQuery: '请求接口地址’,
   *      requestMethod: '请求方法 默认: get',
   *      valueKey(可选): 'value的key, 默认: value',
   *      labelKey(可选): 'label的key, 默认: label'
   *    },
   *    props(可选): {clearable: true}
   * }
   */
  otherAreaColumns: {
    type: Array,
    default() {
      return [
        {
          code: 'amount',
          name: '数量（单位）',
          style: { width: '140px', fontSize: '17px' },
          component: 'panguInputNumber',
          props: { min: 1, clearable: true, required: true },
        },
      ]
    },
  },

  //-------------------初始化弹出框的props--------------------
  modalTransfer: {
    type: Boolean,
    default: true,
  },
  //弹出框标题
  modalTitle: {
    type: String,
    default: '扫码',
  },
  //是否显示模态框
  modalIsShowModal: {
    type: Boolean,
    default: false,
  },
  //模态框宽度
  modalWidth: {
    type: [String, Number],
    default: '1200',
  },
  modalMaskClosable: {
    type: Boolean,
    default: true,
  },
  //扫码的字段
  dataAvailableKey: {
    type: String,
    default: 'amountOut',
  },
  //-------------------后置弹出框的props--------------------

  //是否在页面上
  transfer: {
    type: Boolean,
    default: false,
  },
  //弹出框标题
  title: {
    type: String,
    default: '库存选择',
  },
  //是否显示模态框
  showModal: {
    type: Boolean,
    default: true,
  },
  maskClosable: {
    type: Boolean,
    default: true,
  },
  //模态框宽度
  width: {
    type: [String, Number],
    default: '1200',
  },
  //按钮名称
  sureAndClose: {
    type: String,
    default: '提交并关闭',
  },
  //按钮名称
  sureAndContinue: {
    type: String,
    default: '提交并继续',
  },
  //显示底部按钮
  showFooter: {
    type: Boolean,
    default: false,
  },
  //表格上方的删除
  removeAll: {
    type: Boolean,
    default: false,
  },
  //表格侧边的删除
  menuDeleteShow: {
    type: Boolean,
    default: false,
  },
  //后台请求接口

  urlSaveUrl: {
    type: String,
    default: '',
  },
  //保存的参数
  saveParams: {
    type: Object,
    default: () => ({}),
  },

  //------------顶部搜索-------------/
  //是否显示查询
  isShowQueryGroup: {
    type: Boolean,
    default: false,
  },
  //查询的高级查询地址
  groupSearchFormUrl: {
    type: String,
    default: '',
  },

  //表单信息是否显示
  single: {
    type: Boolean,
    default: false,
  },
  //表单url
  popupFormItemsDefUrl: {
    type: String,
    default: '',
  },
  //--------真分页表格参数--------------/
  //是否显示选择框
  selection: {
    type: Boolean,
    default: true,
  },
  menuAddShow: {
    type: Boolean,
    default: true,
  },
  //是否显示底部按钮
  isShowFooterBtn: {
    type: Boolean,
    default: false,
  },
  //请求地址
  urlQuery: {
    type: String,
    default: '',
  },
  //请求参数
  urlQueryParamter: {
    type: Object,
    default: () => {},
  },
  //请求方法
  urlQueryMethod: {
    type: String,
    default: 'post',
  },
  //表格定义
  modelTableDefUrl: {
    type: String,
    default: '',
  },
  //表格顶部按钮
  buttonMenuListUrl: {
    type: String,
    default: '',
  },
  //行级按钮
  buttonMenuListRowUrl: {
    type: String,
    default: '',
  },
  //删除请求信息
  menuDeleteInfo: {
    type: Object,
    default: () => {
      return {
        url: '',
        method: 'post',
        param: '',
      }
    },
  },
  //是否显示 提交并继续
  isShowContinue: {
    type: Boolean,
    default: false,
  },

  //转换接口
  convertUrl: {
    type: String,
    default: '',
  },
  //提交接口
  addDataUrl: {
    type: String,
    default: '',
  },

  // 更改字段
  changeField: {
    type: String,
    default: 'amountOut',
  },
  //是否跟台
  isFollow: {
    type: Boolean,
    default: false,
  },

  // 传递给自定义序列号扫码的参数
  inputProps: {
    type: Object,
    default() {
      return {}
    },
  },
  // 自定义必填项校验的项
  checkArr: {
    type: Array,
    default() {
      return ['batchNumber', 'periodBegin', 'periodEnd']
    },
  },
}
